// extracted by mini-css-extract-plugin
export default {"column-image__container":"styles_column-image__container__8XxsB","column-image":"styles_column-image__cuztO"};